import i18n from "@/i18n/i18n"
export const type = {
    main: 1,
    sub: 2
}
export const inventoryPriceType = {
    inventory: 0,
    purchase: 1,
    provider: 2
}
export const postingType = {
    unknown:0,
    bond:1,
    materialsJournal:2,
    both: 3
}
export const postingPriorityType = {
    both: 0,
    accountantFirst: 1,
    warehouseWorkersFirst:2,

}
export const materialsJournalsTypes = [
    {
        name: i18n.t('MaterialsJournalPage.materials-journal'),
        value: 0
    },
    {
        name: i18n.t('MaterialsJournalPage.opining-items-journal'),
        value: 1
    },
    {
        name: i18n.t('MaterialsJournalPage.Inventory-reconciliation'),
        value: 2
    }
]
export const postingPriorityTypeValues = [
    {
        name: i18n.t('GlobalSettingsPage.no-priority'),
        value: 0
    },
    {
        name: i18n.t('GlobalSettingsPage.accountant-then-warehouser'),
        value: 1
    },
    {
        name: i18n.t('GlobalSettingsPage.warehouser-then-accountant'),
        value: 2
    }
]
export const invoicesPostingTypeStatuses =[
    {
        name: i18n.t('invoices.fully-posted'),
        id: 0
    },
    {
        name: i18n.t('invoices.warehouse-posted'),
        id: 1
    },
    {
        name: i18n.t('invoices.posted-for-accounting'),
        id: 3
    },
    {
        name: i18n.t('invoices.non-posted'),
        id: 5
    }
]
export const paymentType = {
    notDefined: 0,
    cash: 1,
    debt: 2
}
export const finalType = {
    notDefined: 0,
    operation: 1,
    trade: 2,
    gainsAndLosses: 3,
    budget: 4
}
export const valueTypes = {
    /* the integer and double and boolean all are numbers so you can use only one of them*/
    integer: 0,
    double: 1,
    string: 2,
    dateTime: 3,
    json: 4,
    boolean:5
}
export const userType = {
    notDefined: 0, 
    accountant: 1,
    viewer: 2,
    warehouseKeeper: 3,
    warehouseManger: 4
}

export const invoiceType = {
    buy: 1,
    sale: 2,
    buyRefund: 3,
    saleRefund: 4
}
export const orderType = {
    buy: 1,
    sale: 2
}
export const orderStatuses = [
    {id: 0, name:i18n.t('BuyOrderPage.not-defined')},
    {id: 1, name:i18n.t('BuyOrderPage.in-progress')},
    {id: 2, name:i18n.t('BuyOrderPage.done')}
]
export const orderStatus = {
    notDefined: 0,
    inProgress: 1,
    done: 2
}
export const invoicesTypes = [
    { id: 2, name: i18n.t('invoice-types.sales-invoice') },
    { id: 1, name: i18n.t('invoice-types.purchase-invoice') },
    { id: 4, name: i18n.t('invoice-types.sales-refund-invoice') },
    { id: 3, name: i18n.t('invoice-types.purchases-refund-invoice') },
];
export const invoiceStatuses = [
    {id:1, name: i18n.t('invoices.posted')},
    {id:2, name: i18n.t('invoices.non-posted')}
]
export const journalStatuses = [
    {
        id:0,
        name: i18n.t('all'),
    },
    {
        id:1,
        name: i18n.t('posted')
    },
    {
        id:2,
        name: i18n.t('unposted')
    }
]
export const bondType = {
    cash: 0,
    accounting: 1
};

export const accountConfigType = {
    sales: 1,
    purchases: 2,
    grantedDiscount: 3,
    vestedDiscount: 4,
    retainedEarnings: 5,
    endingInventory: 6,
    openingInventory: 7,
    salesRefund: 8,
    purchasesRefund: 9,
};

export const accountSuggestionType = {
    retainedEarnings: 1,
    openingInventory: 2,
    endingInventory: 3,
};

export const materialCategory = {
    commodity: 1,
    raw: 2,
    indirectRaw: 3,
    inProcess: 4,
    finished: 5,
};
export const quantityStatus = {
    normal: 0,
    belowMinimum: 1,
    aboveMaximum: 2
}
export const quantityStatusValues = [
    {
        name: i18n.t('WarehouseInventoryPage.normal'),
        id: 0
    },
    {
        name: i18n.t('WarehouseInventoryPage.below-minimum'),
        id: 1
    },
    {
        name: i18n.t('WarehouseInventoryPage.above-maximum'),
        id: 2
    }
]
export const transactionType = {
    in: 1,
    out: 2
};

export const InvoicesTransactionType = {
    receipt: 1,
    payment: 2,
    expensesBuy: 3,
    expensesSale: 4
}

export const userPermission = {
    accountant: 1,
    viewer: 2,
    warehouseKeeper: 3,
    warehouseManger: 4,
    advanceAccountant: 5,
    treasurer: 6
}

export const permissionNames = {
    accounting: 0,
    accounts: 1,
    configs: 2,
    currencies: 3,
    customStatements: 4,
    financialFiles: 5,
    fundsFlow: 6,
    users: 7,
    system: 8,
    permissions: 9,
    materialWarehouses: 10,
    materialFlow: 11,
    linkedMaterial: 12,
    transactionBond: 13,
    statistic: 14,
    report: 15,
    posting: 16,
    unPosting: 17
}

export const rolePermissions = {
    undefined: 0,
    read: 1,
    action: 2,
    revolve: 3,
    getOwn: 4
}

export const materialDeliveryStatus = [
    {
        id: 0,
        name: i18n.t('WarehouseInventoryPage.delivered')
    },
    {
        id: 1,
        name: i18n.t('WarehouseInventoryPage.being-received')
    }
    // {
    //     id: 2,
    //     name: i18n.t('WarehouseInventoryPage.being-deliver')
    // }
]

export const logTypes = [
    {
        logType: 0,
        name: i18n.t('AuditLog.accounts')
    },
    {
        logType: 1,
        name: i18n.t('AuditLog.accounting')
    },
    {
        logType: 2,
        name: i18n.t('AuditLog.currencies')
    },
    {
        logType: 3,
        name: i18n.t('AuditLog.financial-file')
    },
    {
        logType: 4,
        name: i18n.t('AuditLog.fund-flow')
    },
    {
        logType: 5,
        name: i18n.t('AuditLog.manufacturing')
    },
    {
        logType: 6,
        name: i18n.t('AuditLog.material-flow')
    },
    {
        logType: 7,
        name: i18n.t('AuditLog.material-warehouse')
    },
    {
        logType: 8,
        name: i18n.t('AuditLog.users')
    }
]

export const actionTypes = [
    {
        type: 0,
        name: i18n.t('AuditLog.fetch'),
    },
    {
        type: 1,
        name: i18n.t('AuditLog.create'),
    },
    {
        type: 2,
        name: i18n.t('AuditLog.edit'),
    },
    {
        type: 3,
        name: i18n.t('AuditLog.delete'),
    },
    {
        type: 4,
        name: i18n.t('AuditLog.post')
    },
    {
        type: 5,
        name: i18n.t('AuditLog.unPost')
    }
]
export const actionType = {
    fetch: 0,
    create: 1,
    update: 2,
    delete: 3,
    post: 4,
    unPost: 5,
}
export const entryLogType = {
    finicalFiles: 'FinicialFiles',
    accounts: 'Accounts',
    contactInfos: 'ContactInfos',
    finicalFilesConfig: 'FinicialFiles_Config',
    currencies: 'Currencies',
    customStatements: 'CustomStatements',
    receiptBonds: 'ReceiptBonds',
    paymentBonds: 'PaymentBonds',
    cashEntries: 'CashEntries',
    accountingEntries: 'AccountingEntries',
    cashBonds: 'CashBonds',
    accountingBonds: 'AccountingBonds',
    receiptEntries: 'ReceiptEntries',
    paymentEntries: 'PaymentEntries',
    subInvoiceTypes: 'SubInvoiceTypes',
    buyInvoices: 'BuyInvocies',
    saleInvoices: 'SaleInvocies',
    buyRefundInvoices: 'BuyRefundInvocies',
    saleRefundInvoices: 'SaleRefundInvocies',
    buyMaterialEntries: 'BuyMaterialEntries',
    saleMaterialEntries: 'SaleMaterialEntries',
    buyRefundMaterialEntries: 'BuyRefundMaterialEntries',
    saleRefundMaterialEntries: 'SaleRefundMaterialEntries',
    roles: 'Roles',
    users: 'Users',
    transactionBonds: 'TransactionBonds',
    transactionEntries: 'TransactionEntries',
    manufacturingFiles: 'ManufacturingFiles',
    manufacturingFileEntries: 'ManufacturingFileEntries',
    manufacturingFileEntryRawMaterials: 'ManufacturingFileEntryRawMaterials',
    materialsJournals: 'MaterialsJournals',
    materialEntries: 'MaterialEntries',
    receiptInvoiceTransactions: 'ReceiptInvoiceTransactions',
    paymentInvoiceTransactions: 'PaymentInvoiceTransactions',
    expensesBuyInvoiceTransactions: 'ExpensesBuyInvoiceTransactions',
    expensesSaleInvoiceTransactions: 'ExpensesSaleInvoiceTransactions',
    materials: 'Materials',
    linkedMaterials: 'LinkedMaterials',
    unitSizes: 'UnitSizes',
    warehouses: 'Warehouses',
    deliveryStatuses: 'DeliveryStatuses',
    invoiceTransactions: 'InvoiceTransactions'
}

export const fullLogTypes = [
    {
        id: entryLogType.finicalFiles,
        name: i18n.t('AuditLog.full-log-types.financial-files'),
    },
    {
        id: entryLogType.accounts,
        name: i18n.t('AuditLog.full-log-types.accounts'),
    },
    {
        id: entryLogType.contactInfos,
        name: i18n.t('AuditLog.full-log-types.contact-infos'),
    },
    {
        id: entryLogType.finicalFilesConfig,
        name: i18n.t('AuditLog.full-log-types.financial-file-config'),
    },
    {
        id: entryLogType.currencies,
        name: i18n.t('AuditLog.full-log-types.currencies'),
    },
    {
        id: entryLogType.customStatements,
        name: i18n.t('AuditLog.full-log-types.custom-statements'),
    },
    {
        id: entryLogType.receiptBonds,
        name: i18n.t('AuditLog.full-log-types.receipt-bonds'),
    },
    {
        id: entryLogType.paymentBonds,
        name: i18n.t('AuditLog.full-log-types.payment-bonds'),
    },
    {
        id: entryLogType.cashEntries,
        name: i18n.t('AuditLog.full-log-types.cash-entries'),
    },
    {
        id: entryLogType.accountingEntries,
        name: i18n.t('AuditLog.full-log-types.accounting-entries'),
    },
    {
        id: entryLogType.cashBonds,
        name: i18n.t('AuditLog.full-log-types.cash-bonds'),
    },
    {
        id: entryLogType.accountingBonds,
        name: i18n.t('AuditLog.full-log-types.accounting-bonds'),
    },
    {
        id: entryLogType.receiptEntries,
        name: i18n.t('AuditLog.full-log-types.receipt-entries'),
    },
    {
        id: entryLogType.paymentEntries,
        name: i18n.t('AuditLog.full-log-types.payment-entries'),
    },
    {
        id: entryLogType.subInvoiceTypes,
        name: i18n.t('AuditLog.full-log-types.sub-invoices'),
    },
    {
        id: entryLogType.buyInvoices,
        name: i18n.t('AuditLog.full-log-types.buy-invoices'),
    },
    {
        id: entryLogType.saleInvoices,
        name: i18n.t('AuditLog.full-log-types.sale-invoices')
    },
    {
        id: entryLogType.buyRefundInvoices,
        name: i18n.t('AuditLog.full-log-types.buy-refund-invoices'),
    },
    {
        id: entryLogType.saleRefundInvoices,
        name: i18n.t('AuditLog.full-log-types.sale-refund-invoices'),
    },
    {
        id: entryLogType.buyMaterialEntries,
        name: i18n.t('AuditLog.full-log-types.buy-material-entries'),
    },
    {
        id: entryLogType.saleMaterialEntries,
        name: i18n.t('AuditLog.full-log-types.sale-material-entries'),
    },
    {
        id: entryLogType.buyRefundMaterialEntries,
        name: i18n.t('AuditLog.full-log-types.buy-refund-material-entries'),
    },
    {
        id: entryLogType.saleRefundMaterialEntries,
        name: i18n.t('AuditLog.full-log-types.sale-refund-material-entries'),
    },
    {
        id: entryLogType.roles,
        name: i18n.t('AuditLog.full-log-types.roles'),
    },
    {
        id: entryLogType.users,
        name: i18n.t('AuditLog.full-log-types.users'),
    },
    {
        id: entryLogType.transactionBonds,
        name: i18n.t('AuditLog.full-log-types.transaction-bonds'),
    },
    {
        id: entryLogType.transactionEntries,
        name: i18n.t('AuditLog.full-log-types.transaction-entries'),
    },
    {
        id: entryLogType.manufacturingFiles,
        name: i18n.t('AuditLog.full-log-types.manufacturing-files'),
    },
    {
        id: entryLogType.manufacturingFileEntries,
        name: i18n.t('AuditLog.full-log-types.manufacturing-file-entries'),
    },
    {
        id: entryLogType.manufacturingFileEntryRawMaterials,
        name: i18n.t('AuditLog.full-log-types.manufacturing-file-entry-raw-materials'),
    },
    {
        id: entryLogType.materialsJournals,
        name: i18n.t('AuditLog.full-log-types.material-journals'),
    },
    {
        id: entryLogType.materialEntries,
        name: i18n.t('AuditLog.full-log-types.material-entries'),
    },
    {
        id: entryLogType.receiptInvoiceTransactions,
        name: i18n.t('AuditLog.full-log-types.receipt-invoice-transactions'),
    },
    {
        id: entryLogType.paymentInvoiceTransactions,
        name: i18n.t('AuditLog.full-log-types.payment-invoice-transaction'),
    },
    {
        id: entryLogType.expensesBuyInvoiceTransactions,
        name: i18n.t('AuditLog.full-log-types.expenses-buy-invoice-transaction'),
    },
    {
        id: entryLogType.expensesSaleInvoiceTransactions,
        name: i18n.t('AuditLog.full-log-types.expenses-sale-invoice-transaction'),
    },
    {
        id: entryLogType.materials,
        name: i18n.t('AuditLog.full-log-types.materials'),
    },
    {
        id: entryLogType.linkedMaterials,
        name: i18n.t('AuditLog.full-log-types.linked-materials'),
    },
    {
        id: entryLogType.unitSizes,
        name: i18n.t('AuditLog.full-log-types.unit-sizes'),
    },
    {
        id: entryLogType.warehouses,
        name: i18n.t('AuditLog.full-log-types.warehouses'),
    },
    {
        id: entryLogType.deliveryStatuses,
        name: i18n.t('AuditLog.full-log-types.delivery-statuses')
    },
    {
        id: entryLogType.invoiceTransactions,
        name: i18n.t('AuditLog.full-log-types.invoice-transactions')
    }
]

export const materialEditTypes = [
    {
        id: 2,
        name: i18n.t('material-edit-types.names')
    },
    {
        id: 1,
        name: i18n.t('material-edit-types.data')
    },
    {
        id: 0,
        name: i18n.t('material-edit-types.all')
    },
]

export const offerType = {
    buy: 1,
    sale: 2
}
export const offerStatuses = [
    {
        id: 0,
        name: i18n.t('PriceOfferPage.draft')
    },
    {
        id: 1,
        name:  i18n.t('PriceOfferPage.sent')
    },
    {
        id: 2 ,
        name: i18n.t('PriceOfferPage.approved')
    },
    {
        id: 3,
        name: i18n.t('PriceOfferPage.rejected')
    },
    // will be add later
    // {
    //     id: 4,
    //     name: 'converted to invoice'
    // }
]
export const offerStatus = {
    draft: 0,
    sent: 1,
    approved: 2,
    rejected: 3
}
export const statementMatching = {
    matched: 0,
    notMatched: 1
}
export const paymentReceiptBondType = {
    receipt: 1,
    payment: 2
}